module.exports = __webpack_public_path__ + "static/media/zodiac_killer.c258e3df.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/rimages/zodiac_killer.jpg
// module id = 107
// module chunks = 0